import React, { Component } from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { Pressure as PressureAction } from '~/actions';
import { PressureFilters, ContentSection, SeepageV2Graph } from '~/components';
import ContentData from '~/hoc/ContentData';
import moment from '~/_moment';

const Option = Select.Option;

class SeepageGraph extends Component {
  constructor(props) {
    super(props);
    const { loadPressure } = props;
    loadPressure(moment().format('YYYY-MM-DD'));
  }

  componentWillUnmount() {
    const { resetPressure } = this.props;
    resetPressure();
  }

  render() {
    const {
      profile: {
        site_name: siteName,
        pressure: { enable: isPressureEnable },
        firstRun,
        seepage_v2: { sensors: seepageV2Sensors },
      },
      pressure,
      seepageV2: { data: seepageV2Data },
      loadPressure,
      handleChangeDate,
    } = this.props;

    if (!isPressureEnable) return null;

    const moduleName = 'ระบบรายงานสภาพการรั่วซึมของตัวเขื่อน';

    return (
      <ContentSection>
        <Helmet>
          <title>{moduleName}</title>
        </Helmet>
        <ContentData title={moduleName} isLoading={pressure.isloading}>
          <PressureFilters
            siteName={siteName}
            subTitle={moduleName}
            dateFormat="YYYY-MM-DD"
            timeFormat="HH:mm"
            dateValue={pressure.date}
            showTimePicker={false}
            isPressureloading={pressure.isloading}
            handleLoadData={() => loadPressure(pressure.date)}
            handleChangeDate={handleChangeDate}
            disabledDate={moment(firstRun).subtract(1, 'days')}
          />
          <SeepageV2Graph sensor={seepageV2Sensors} data={seepageV2Data} />
        </ContentData>
      </ContentSection>
    );
  }
}

export default connect(
  ({ DamProfile, SeepageV2, Pressure }) => ({
    profile: DamProfile,
    pressure: Pressure,
    seepageV2: SeepageV2,
  }),
  {
    loadPressure: PressureAction.loadPressureData,
    handleChangeDate: PressureAction.changeDate,
    resetPressure: PressureAction.resetPressureData,
  },
)(SeepageGraph);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/SeepageGraph/index.js